<template>
  <div class="pointer wrap" @click="clickCard">
    <div
      class="skill-img"
      :style="{
        backgroundImage: `url(${info.gameImageUrl})`,
      }"
    />
    <div class="skill-info">
      <div class="skill-name">{{ info.gameName }}</div>
      <div v-if="info.status === 'Checking'" class="skill-state">審核中</div>
      <div v-else-if="info.status === 'Checked'" class="skill-state">
        <span>審核通過，請完善技能信息</span>
        <fps-icon type="arrow-right" size="18" />
      </div>
      <div v-else-if="info.status === 'Fail'" class="skill-state">
        <span>審核未通過，去修改</span>
        <fps-icon type="arrow-right" size="18" />
      </div>
      <div v-else-if="info.status === 'Success'" class="skill-state">
        <span class="price">{{ info.price }}</span>
        <span class="unit">幣/{{ info.salesUnit | salesUnitTranslate }}</span>
      </div>
      <div v-if="info.status === 'Success'" class="order-state">
        <span>{{ info.settingStatus === 'OPEN' ? '接單中' : '暫不接單' }}</span>
      </div>
    </div>
    <fps-switch
      v-if="info.status === 'Success'"
      class="switch"
      :value="info.settingStatus === 'OPEN'"
      :loading="loading"
      @change="changeStatus"
    />
    <div v-if="info.status === 'Fail'" class="delete-skill" @click.stop="deleteSkill">
      <fps-icon class="delete-icon" type="close" size="8" />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    info: {
      type: Object,
      require: true,
    },
  },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    clickCard() {
      const { status, id } = this.info
      switch (status) {
        case 'Checking': {
          this.$router.push({
            path: '/settled',
            query: {
              type: 'checking',
            }
          })
          break
        }
        case 'Fail': {
          this.$router.push({
            path: '/settled',
            query: {
              type: 'reapply',
              id,
            }
          })
          break
        }
        case 'Checked':
        case 'Success': {
          this.$router.push({
            path: '/player/skill/detail',
            query: {
              skillId: this.info.id,
              gameId: this.info.gameId,
            }
          })
          break
        }
      }
    },
    changeStatus() {
      const { settingStatus, id } = this.info
      if (settingStatus === 'SYSTEM_CLOSE') {
        this.$message('您的賬戶存在違規行為，已暫停技能上架，詳情請咨詢管理員')
        return
      }
      if (this.loading) return
      this.loading = true
      const status = settingStatus === 'CLOSE' ? 'OPEN' : 'CLOSE'
      this.$http.post('/player/skill/certification/save', {
        settingStatus: status,
        skillId: id,
      }).then(() => {
        this.$emit('changeStatus', { status, skill: this.info })
        this.loading = false
      }).catch(err => {
        this.loading = false
        console.log(err)
      })
    },
    deleteSkill() {
      this.$confirm({
        content: '刪除技能後將不再保存填寫的信息，確定刪除該技能嗎？',
        confirmButtonText: '再想想',
        cancelButtonText: '確認刪除',
      }).then(() => {
      }).catch(() => {
        this.$http.post('/player/skill/certification/delete', { skillId: this.info.id })
          .then(() => {
            this.$message.success('刪除成功')
            this.$emit('deleteSkill')
          })
          .catch(() => {
            this.$message.error('刪除失敗')
          })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .wrap {
    position: relative;
    .delete-skill {
      position: absolute;
      width: 24px;
      height: 24px;
      display: flex;
      justify-content: center;
      align-items: center;
      top: 4px;
      right: 4px;
      // .delete-icon {
      //   height: 12px;
      // }
    }
  }
  .switch {
    align-self: flex-start;
    margin-bottom: 1px;
  }
  .skill-img {
    width: 72px;
    height: 68px;
    background: #fff no-repeat top center / 100%;
    border-radius: 8px;
    margin-right: 12px;
  }
  .skill-info {
    flex: 1;
    height: 100%;
    display: flex;
    flex-direction: column;
    .skill-name {
      font-weight: 500;
      font-size: 16px;
      line-height: 20px;
      color: $color-gray-1;
    }
    .skill-state {
      display: flex;
      margin-top: 6px;
      align-items: center;
      color: $color-link;
      .price {
        font-weight: 500;
        font-size: 14px;
        line-height: 17px;
        color: $color-gray-2;
      }
      .unit {
        font-size: 14px;
        line-height: 20px;
        color: $color-gray-2;
        margin-left: 2px;
      }
    }
    .order-state {
      margin-top: 4px;
      font-size: 12px;
      line-height: 18px;
      color: $color-gray-2;
    }
  }
</style>
